module.exports =
  '_PASSWORD':
    'NEW':
      'TITLE': 'パスワードを忘れた方はこちら'
      'EMAIL_ADDR': 'メールアドレス'
      'SUCCESS': 'パースワードのリセット方法を数分以内にメールでご連絡します。'
      'ERROR': 'メールアドレスが見つかりません。'
      'PAGE_TITLE': 'ご登録のメールアドレスを入力し、送信ボタンを押してください。'
    'EDIT':
      'TITLE': 'パスワードリセット'
      'PAGE_TITLE': '新しいパスワードを入力してください。'
      'NEW_PASSWORD': '新しいパスワード'
      'CONFIRM_PASSWORD': '新しいパスワード（確認）'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/password/i18n/ja.coffee